import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/dashboard.actions';
import * as home from '../../../actions/process.home.actions';

//import Error from '../../dialogs/Error';
import Snackbar from '../../labels/Snackbar';
import Loading from '../../dialogs/loading';

import EditDashboard from './Editdashboard';
import Dashboard from './Dashboard';
import watermark from '../../../images/watermark.png';

// eslint-disable-next-line
import style from './_styles.css';


class Index extends React.Component {

    constructor(props) {
        super(props);
        if(sessionStorage.token){
            const { dashboard_has_error, indicators_has_error } = props;
            if ((dashboard_has_error && dashboard_has_error.hasErrored) || (indicators_has_error && indicators_has_error.hasErrored)) {
                props.loadDashboard();
            }
        }

        this.state = { 
            edit: false,
            dashboard_has_error: undefined,
            indicators_has_error: undefined,
            height: window.innerHeight, 
            width: window.innerWidth
        };
        this.updateDimensions = this.updateDimensions.bind(this);
        
        // Additionally I could have just used an arrow function for the binding `this` to the component...
        window.addEventListener("resize", this.updateDimensions);
    }

    static getDerivedStateFromProps(props, state) {
        const { dashboard_has_error, indicators_has_error } = props;
        if (dashboard_has_error !== state.dashboard_has_error || indicators_has_error !== state.indicators_has_error) {
            state.dashboard_has_error = dashboard_has_error;
            state.indicators_has_error = indicators_has_error;
            return state;
        }
        return null;
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        this.setState({
            height: window.innerHeight, 
            width: window.innerWidth
        });
    }

    handleCloseMessage = () => {
        this.setState({error: undefined});
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleEdit = (edit) => {
        this.setState({edit: edit});
    }

    handleSummit = (dashboard) => {
        this.props.updateDashboard(dashboard)
            .then(() => this.props.loadDashboard())
            .catch((error) => this.setState({error: error.message}));
        this.setState({ edit: false });
    }

    render() {
        const { edit, indicators_has_error, dashboard_has_error, error, height, width } = this.state;
        const { dashboard_is_loading } = this.props;

        if ((dashboard_has_error && dashboard_has_error.hasErrored) || (indicators_has_error && indicators_has_error.hasErrored)) {
            return  <div className="bg_ice_blue flex_full_column height100 center">
                        <span
                            className={'barlow_medium c_cool_grey margin_bottom_48'}
                            >
                                <FormattedMessage id="welcomeToiFlares" />
                        </span>
                        <img
                            src={`${watermark}`}
                            alt="iFlares"
                            height="128"
                            width="128"
                            />
                        <span className={'barlow_regular c_cool_grey margin_top_32'}>
                            <FormattedMessage id="selectaoption" />
                        </span>
                    </div>;
        } else {
            return (
                <div id="dasboard-main" className="width100">
                    {dashboard_is_loading &&
                        <Loading open opacity />
                    }
                    {edit
                        ? <EditDashboard 
                            {...this.props} 
                            onSummit={this.handleSummit}
                            onCancel={this.handleEdit}
                            />
                        : <Dashboard 
                            {...this.props} 
                            width={width}
                            height={height}
                            onEdit={this.handleEdit}
                            />
                    }
                    {error && (
                        <Snackbar
                            open={true}
                            variant="warning"
                            text={error}
                            onClose={this.handleCloseMessage.bind(this)}
                        />
                    )}
                    
                </div>
            );
        }
    }
}

Index.propTypes = {
    dashboard: PropTypes.array.isRequired,
    indicators: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        dashboard: state.dashboard,
        dashboard_charts: state.dashboard_charts,
        indicators: state.indicators,
        dashboard_has_error: state.dashboard_has_error,
        indicators_has_error: state.indicators_has_error,
        dashboard_is_loading: state.dashboard_is_loading
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(mapStateToProps,mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/components/complex/dashboard/Index.js